import * as React from 'react';
import { AllPopupWrap } from 'footer/AllPopupWrap';
import { AllPopupOverlay } from 'style/CommonStyledComponents';
import { useZstdFooter } from 'footer/useZstdFooter';

const InfoPopup = React.lazy(() => import('footer/popup/InfoPopup').then((module) => ({ default: module.InfoPopup })));
const TermsDetailPopup = React.lazy(() =>
  import('header/popup/TermsDetailPopup').then((module) => ({ default: module.TermsDetailPopup }))
);
const TermsDetailPrivatePopup = React.lazy(() =>
  import('header/popup/TermsDetailPrivatePopup').then((module) => ({ default: module.TermsDetailPrivatePopup }))
);
const ChatbotTermsPopup = React.lazy(() =>
  import('footer/popup/ChatbotTerms').then((module) => ({ default: module.ChatbotTermsPopup }))
);

type Props = {};
export const FooterPopup = (props: Props) => {
  const { showInfoPopup, setShowInfoPopup } = useZstdFooter();
  const { showChatbotTermsPopup, setShowChatbotTermsPopup } = useZstdFooter();

  const showInfoPopupFunc = (showInfoPopup: boolean) => {
    setShowInfoPopup(showInfoPopup);
  };

  const showChatbotTermsPopupFunc = (showChatbotTermsPopup: boolean) => {
    setShowChatbotTermsPopup(showChatbotTermsPopup);
  };

  return (
    <>
      <React.Suspense fallback={<div></div>}>
        <AllPopupWrap>
          {showInfoPopup && <InfoPopup showInfoPopupFunc={showInfoPopupFunc} />}
          {showChatbotTermsPopup && <ChatbotTermsPopup showChatbotTermsPopupFunc={showChatbotTermsPopupFunc} />}
        </AllPopupWrap>
      </React.Suspense>
      {(showInfoPopup || showChatbotTermsPopup) && <AllPopupOverlay aria-label={'popup-overlay'} />}
    </>
  );
};
